// Core
import React from "react"
import styled from "styled-components"

// General Components
import BaseContainer from "../../../../components/BaseContainer"
import Title from "../../../../components/Title"

// Components
import LocationsContainer from "./components/LocationsContainer"

// Styles
const Section = styled.section`
  padding-top: 10rem;
  padding-bottom: 10rem;

  background-color: #000000;
  text-align: center;
`

const CopyContainer = styled.div`
  margin: 0 auto;
`

export default function Locations() {
  return (
    <Section>
      <BaseContainer displayInline>
        <CopyContainer>
          <Title center darkBG>
            Onde estamos?
          </Title>
        </CopyContainer>
      </BaseContainer>

      <BaseContainer>
        <LocationsContainer />
      </BaseContainer>
    </Section>
  )
}
